import { Market } from '@avp/context-claims';
import { Locale } from './locales';
import { GiveawayTaskStatus } from './types';

export interface SubcycleData {
  subcycles: { [subCycle: string]: number };
  unit: string;
}
export interface CycleData {
  wltp?: SubcycleData;
  nedc?: SubcycleData;
}
export interface ConsumptionAndEmissionData {
  eec?: string;
  fuels: {
    [fuel: string]: {
      consumption?: CycleData;
      emission?: CycleData;
      range?: CycleData;
    };
  };
}

export interface VMSVideo {
  uuid: string;
  resolutions: {
    '500p': string;
    '720p': string;
    '1080p': string;
  };
}

export interface GiveawayMetadata {
  page: string;
  section: string;
  index: number;
}

export interface GiveawayAsset {
  url: string;
  metadata: GiveawayMetadata;
}

export interface CreateGiveawayRequest {
  marketingCode: string;
  showVMSContent: boolean;
  renderCameraFlight?: boolean;
  dealerAddress?: string;
  dealerLink?: string;
  userType?: string;
  dealerId?: string;
  locale: string;
  market: string;
}

export interface CreateGiveawayResponse {
  id: string;
}

export const domainName = 'dga.avp.tech';

export enum Stage {
  DEV = 'dev',
  TEST = 'test',
  PROD = 'prod'
}

export interface GiveawayResponse {
  id: string;
  marketingCode: string;
  prString: string;
  carModel?: string;
  market: Market;
  locale: Locale;
  createdAt: string;
  updatedAt: string;
  giveawayStatus: GiveawayTaskStatus;
  dealerAddress?: string;
  dealerLink?: string;
  userType?: string;
  dealerId?: string;
  renderCameraFlight?: boolean;
  cameraFlightVideo?: string;
  vmsVideos?: VMSVideo[];
  thumbnail?: string;
  assets: GiveawayAsset[];
  consumptionAndEmissionData?: ConsumptionAndEmissionData;
  oscarConfigId?: string; // only set in case of brand is Cupra
}
